import { ChannelTypeEnum }    from "@alinmaCoreModule/enums/channel-type.enum";
import { LangEnum }           from "@alinmaCoreModule/enums/lang.enum";
import { IEnvironmentConfig } from "@alinmaCoreModule/models/environment-config";
import { ALINMA_APP_CONFIG }  from "@alinmaEnvironments/alinma-app-config";

export const APP_CONFIG: IEnvironmentConfig = {

  // alinma config
  ...ALINMA_APP_CONFIG,
  channel: ChannelTypeEnum.api,

  prefix: "develop",

  // TODO: to check
  channelId  : "retailInternetBanking",
  defaultLang: LangEnum.EN
};
